import React from 'react';

/**
 * Clear Defense AI Logo Component
 * Supports different sizes and variants (icon only, text only, full)
 */
export const Logo = ({ 
  variant = 'full',  // 'full' | 'icon' | 'text'
  size = 'default',  // 'sm' | 'default' | 'lg' | 'xl'
  className = '',
  showSubtext = false,
  subtext = 'Cybersecurity Platform'
}) => {
  const sizes = {
    sm: { icon: 'w-6 h-6', text: 'h-4', container: 'gap-2' },
    default: { icon: 'w-10 h-10', text: 'h-6', container: 'gap-3' },
    lg: { icon: 'w-12 h-12', text: 'h-8', container: 'gap-3' },
    xl: { icon: 'w-16 h-16', text: 'h-10', container: 'gap-4' }
  };

  const sizeConfig = sizes[size] || sizes.default;

  if (variant === 'icon') {
    return (
      <img 
        src="/assets/logos/logo-icon.png" 
        alt="Clear Defense AI" 
        className={`${sizeConfig.icon} object-contain ${className}`}
      />
    );
  }

  if (variant === 'text') {
    return (
      <img 
        src="/assets/logos/logo-text.png" 
        alt="Clear Defense AI" 
        className={`${sizeConfig.text} object-contain ${className}`}
      />
    );
  }

  // Full logo (icon + text)
  return (
    <div className={`flex items-center ${sizeConfig.container} ${className}`}>
      <img 
        src="/assets/logos/logo-icon.png" 
        alt="Clear Defense AI" 
        className={`${sizeConfig.icon} object-contain`}
      />
      <div className="flex flex-col">
        <img 
          src="/assets/logos/logo-text.png" 
          alt="Clear Defense AI" 
          className={`${sizeConfig.text} object-contain`}
        />
        {showSubtext && (
          <p className="text-xs text-slate-500">{subtext}</p>
        )}
      </div>
    </div>
  );
};

/**
 * Simple Logo Icon - For places where just the icon is needed
 */
export const LogoIcon = ({ size = 'default', className = '' }) => {
  const sizes = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    default: 'w-8 h-8',
    lg: 'w-10 h-10',
    xl: 'w-12 h-12'
  };

  return (
    <img 
      src="/assets/logos/logo-icon.png" 
      alt="Clear Defense AI" 
      className={`${sizes[size] || sizes.default} object-contain ${className}`}
    />
  );
};

/**
 * Logo Text - For places where just the text logo is needed  
 */
export const LogoText = ({ size = 'default', className = '' }) => {
  const sizes = {
    sm: 'h-4',
    default: 'h-6',
    lg: 'h-8',
    xl: 'h-10'
  };

  return (
    <img 
      src="/assets/logos/logo-text.png" 
      alt="Clear Defense AI" 
      className={`${sizes[size] || sizes.default} object-contain ${className}`}
    />
  );
};

export default Logo;
